import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Container, Row, Col} from 'reactstrap';
import {prepareUrl} from '../../../utilities/StringHelpers/StringHelpers';
import EpiContext from '@episerver/spa-core/Spa';

const MarketBadges = (props) => {
  return (
    <Container className='badges-container'>
      <Row>
        <Col className='badges'>
          <Row>
            <Col>
              <p className='badges__text'>דברים טובים מחכים לכם באפליקציה</p>
            </Col>
          </Row>
          <div className='badges__container'>
            <div>
              <Image src={require('./images/google-play-badge.svg')}
                alt='Google badge'
                className='badges__container__google'
                onClick={() => props.markets('google')} />
            </div>
            <div>
              <Image src={require('./images/app-store-badge.svg')}
                alt='Apple badge'
                className='badges__container__apple'
                onClick={() => props.markets('apple')} />
            </div>
          </div>
        </Col>
      </Row>
      {/* <Row>
        <Col className='btn-instructions-holder'>
          <div className='btn-instructions'>
            <button className='btn-instructions__body' onClick={() => prepareUrl(props.saleInfo.instructionLink, EpiContext)}>
              <span className='btn-instructions__text'>הנחיות התקנה</span>
            </button>
          </div>
        </Col>
      </Row> */}
    </Container>
  );
};

export default MarketBadges;
